import React from 'react';
import LocationTemplate from './LocationTemplate';

const BethelPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Bethel"
      stateName="North Carolina"
      countyName="Pitt"
      zipCodes={["27812"]}
      latitude={35.8074}
      longitude={-77.3761}
      population={1577}
      historicalFact="Incorporated in 1883, named after Bethel Church which was established in the area."
      nearbyTowns={[
        "Greenville, NC",
        "Winterville, NC",
        "Fountain, NC",
        "Falkland, NC",
        "Farmville, NC",
        "Rocky Mount, NC",
        "Wilson, NC",
        "Tarboro, NC"
      ]}
    />
  );
};

export default BethelPage;